import React from "react";
import styled from "styled-components";
import { Line } from "react-chartjs-2";
import { Icon } from "@blueprintjs/core";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ChartOptions,
  ChartData,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const CardContainer = styled.div`
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.1));
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`;

const TitleText = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

const SubTitle = styled.div`
  font-size: 14px;
  color: #4caf50; // Adjust color as needed
  margin-top: 10px;
`;

const Amount = styled.span`
  font-weight: bold;
  color: #333;
`;

type HeadCountChartProps = {
  data: number[];
  labels: string[];
  funding: string;
  stage: string;
};

const HeadCountChart = ({
  data,
  labels,
  funding,
  stage,
}: HeadCountChartProps) => {
  const chartData: ChartData<"line"> = {
    labels,
    datasets: [
      {
        label: "Headcount",
        data,
        borderColor: "#6a0dad",
        backgroundColor: "rgba(138, 43, 226, 0.2)",
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const chartOptions: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `${value}`,
        },
      },
      y1: {
        position: "right",
        beginAtZero: true,
        ticks: {
          callback: (value) => `$${value}M`,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `Headcount: ${context.raw}`,
        },
      },
    },
  };

  return (
    <CardContainer>
      <Header>
        <div className="fs-16">Headcount</div>
        <div className="fs-16">Funding</div>
      </Header>
      <div >
        <Line data={chartData} options={chartOptions} />
      </div>
      {/* <SubTitle>
        {stage} <Amount>{funding}</Amount>
      </SubTitle> */}
    </CardContainer>
  );
};

export default HeadCountChart;
